import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2, Gamepad2 } from "lucide-react";
import api from "@/lib/api";
import { ContentCard } from "@/components/ContentCard";
import { useAuth } from "@/context/AuthContext";

export default function Games() {
  const { t } = useTranslation();
  const [genres, setGenres] = useState([]);
  const [active, setActive] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { kids } = useAuth();

  useEffect(() => { api.get("/games/genres").then(({ data }) => setGenres(data)); }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/games", { params: { genre: active, kids, limit: 120 } })
      .then(({ data }) => setItems(data.items)).finally(() => setLoading(false));
  }, [active, kids]);

  return (
    <div className="pt-24 px-4 sm:px-8 lg:px-12 pb-20 min-h-screen" data-testid="games-page">
      <div className="flex items-center gap-3 mb-2">
        <Gamepad2 className="text-pink" size={28} />
        <h1 className="font-head text-3xl sm:text-4xl font-extrabold">{t("games.title")}</h1>
      </div>
      <p className="text-zinc-400 mb-6">{t("games.subtitle")}</p>

      <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-4 mb-4" data-testid="game-genre-filters">
        <button onClick={() => setActive("")} data-testid="game-genre-all"
          className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${active === "" ? "bg-pink text-white" : "bg-white/10 text-zinc-300 hover:bg-white/20"}`}>
          {t("common.allGames")}
        </button>
        {genres.map((g) => (
          <button key={g} onClick={() => setActive(g)} data-testid={`game-genre-${g.toLowerCase().replace(/\s+/g, "-")}`}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${active === g ? "bg-pink text-white" : "bg-white/10 text-zinc-300 hover:bg-white/20"}`}>
            {g}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-pink" size={36} /></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((it) => <ContentCard key={it.id} item={it} />)}
        </div>
      )}
    </div>
  );
}
